//footer
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <footer className="site-footer">
        <div className="container">
          <p className="copyright-text">
            Copyright &copy; 2022 All Rights Reserved by <span>LARK</span>🐣
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
